
export const logout = () => async (dispatch) => {
    localStorage.clear()
    dispatch({ type: 'USER_LOGOUT' })
    dispatch({ type: 'AUTH_LOGOUT' })
    

}